import axios from "axios";
import API from "../helpers/api";

export const getMDSearchlist = (searchItem) => {
  let url = `${API.MDSearch}?MinYear=${searchItem.minyear}&MdIdNo=${searchItem.mdidno}&MaxYear=${searchItem.maxyear}&Supplier=${searchItem.supplier}&SDocIdNo=${searchItem.sdocid}&ProductName=${searchItem.productname}&ProductNumber=${searchItem.productnumber}&SortOrder=${searchItem.sortorder}&SortBy=${searchItem.sortby}&PageSize=${searchItem.pagesize}&PageNumber=${searchItem.pagenumber}`;
  return dispatch => {
    dispatch({
      type: "MDSearchIsTrue",
      data: searchItem
    })
    axios.get(url)
      .then((response) => {
        dispatch({
          type: "GetMDSearchSuccess",
          data: response.data,
        })
      })
      .catch((error) => {
        dispatch({
          type: "GetMDSearchFailure",
          error: "ERROR"
        })
      })
  }
}

export const getMDDetails = (mdId) => {
  let url = `${API.GetMaterialDeclaration}?MaterialDeclarationId=${mdId}`;
  return dispatch => {
    axios.get(url)
      .then((response) => {
        dispatch(getSDOcCompanyList(response.data.companyName))
        dispatch({
          type: "GetMaterialDeclarationSuccess",
          data: response.data,
        })
      })
      .catch((error) => {
        dispatch({
          type: "GetMaterialDeclarationFailure",
          error: "ERROR"
        })
      })
  }
}

export const getCompanyList = () => {
  let url = `${API.CompanyList}`;
  return dispatch => {
    axios.get(url)
      .then((response) => {
        dispatch({
          type: "GetCompanyNameSuccess",
          data: response.data,
        })
      })
      .catch((error) => {
        dispatch({
          type: "GetCompanyNameFailure",
          error: "ERROR"
        })
      })
  }
}

export const getSDOcCompanyList = (companyName, attachmentId) => {
  let url = `${API.SDocCompanyList}?companyName=${companyName ?? ""}&attachmentId=${attachmentId ?? 0}`;
  return dispatch => {
    axios.get(url)
      .then((response) => {
        dispatch({
          type: "GetSDocCompanyNameSuccess",
          data: response.data,
        })
      })
      .catch((error) => {
        dispatch({
          type: "GetSDocCompanyNameFailure",
          error: "ERROR"
        })
      })
  }
}